var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_vm.detect == 'pc' ? _c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("교환 내역")])]) : _vm._e(), _c('v-divider', {
    staticClass: "d-md-none"
  }), _c('mypage-dashboard-head', {
    staticClass: "mb-2 mb-md-12",
    class: {
      'mt-n7': _vm.detect == 'mobile'
    }
  }), _c('v-card', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    class: {
      'pa-0': _vm.detect == 'pc'
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('exchange-bulk-list-filter')], 1), _c('exchange-bulk-list-type', {
    staticClass: "mb-2 mb-md-12"
  }), _c('div', [_c('v-data-table', _vm._b({
    staticClass: "exchange-table",
    attrs: {
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value,
              item = _ref.item;
          return [_c('span', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    }), {
      key: "item.cash",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('exchange-bulk-item-cash', _vm._b({
          on: {
            "input": _vm.updateItem
          }
        }, 'exchange-bulk-item-cash', {
          value: item
        }, false))];
      }
    }, {
      key: "item.gift",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('exchange-bulk-item-gift', _vm._b({
          on: {
            "input": _vm.updateItem
          }
        }, 'exchange-bulk-item-gift', {
          value: item
        }, false))];
      }
    }, {
      key: "item.prev",
      fn: function fn(_ref4) {
        var value = _ref4.value,
            item = _ref4.item,
            header = _ref4.header;
        return [_c('exchange-bulk-item-prev', _vm._b({
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref5) {
              var attrs = _ref5.attrs,
                  on = _ref5.on;
              return [_c('v-card', _vm._g(_vm._b({
                attrs: {
                  "color": "transparent",
                  "elevation": "0"
                }
              }, 'v-card', attrs, false), on), [_vm._v(" " + _vm._s(header.formatter.bind(item)(value, item)) + " ")])];
            }
          }], null, true)
        }, 'exchange-bulk-item-prev', {
          value: item
        }, false))];
      }
    }, {
      key: "item.undo",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('exchange-bulk-item-undo', _vm._b({
          on: {
            "input": _vm.updateItem
          }
        }, 'exchange-bulk-item-undo', {
          value: item
        }, false))];
      }
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    itemsPerPage: -1
  }, false))], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', _vm._b({
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  }, 'v-pagination', {
    value: _vm.page,
    length: _vm.pageCount,
    'total-visible': 11
  }, false))], 1)], 1)], 1)], 1), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }